import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const AnalyticsHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Analytics and Reporting
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Gain valuable insights into your hiring process with our comprehensive analytics dashboard.
            Track key metrics, identify trends, and make data-driven decisions to improve your recruitment strategy.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Key Performance Metrics
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Monitor essential hiring metrics including time-to-hire, application conversion rates,
            candidate sources, and interview success rates. Track your progress against industry benchmarks.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Custom Reports
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Create customized reports to analyze specific aspects of your hiring process. Filter data by
            time period, job type, department, or any other relevant criteria.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Candidate Pipeline Analysis
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Visualize your candidate pipeline and identify bottlenecks in your hiring process. Track
            candidate progression through different stages and optimize your workflow accordingly.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Diversity and Inclusion Metrics
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Monitor diversity metrics across your hiring process. Track representation at different
            stages and ensure your recruitment practices promote inclusivity.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/analytics"
              color="primary"
              variant="contained"
            >
              View Analytics
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default AnalyticsHelp; 